import validate from "/opt/cargolink/app/cargolink-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/cargolink/app/cargolink-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/cargolink/app/cargolink-app/middleware/auth.js"),
  guest: () => import("/opt/cargolink/app/cargolink-app/middleware/guest.js")
}